import { FC, useState } from "react"
import styled from "styled-components"
import { LazyMotion, m } from "framer-motion"
const loadFeatures = () => import("@lib/framer-motion").then(res => res.default)

import { AccordionItemChevron } from "@components/ui"
interface Props {
  label: string
}

export const ProductAccordion: FC<Props> = ({ children, label }) => {
  const [isActive, setIsActive] = useState(true)

  return (
    <div>
      <Label onClick={() => setIsActive(!isActive)}>
        {label}
        <Chevron $isActive={isActive} />
      </Label>
      <LazyMotion strict features={loadFeatures}>
        <Body
          initial={isActive}
          animate={{
            height: isActive ? "auto" : "0",
          }}
          transition={{ duration: 0.25 }}
        >
          <BodyInner>{children}</BodyInner>
        </Body>
      </LazyMotion>
    </div>
  )
}

const Label = styled.label`
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 0;
  border-top: ${({ theme }) => `1px solid ${theme.color.greyLight}`};
  font-family: ${({ theme }) => theme.font.heading};
  font-size: 1.8rem;
  line-height: 3rem;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

const Body = styled(m.div)`
  overflow: hidden;
  height: auto;
`

const BodyInner = styled.div`
  padding: 0 0 1.8rem;
`

const Chevron = styled(AccordionItemChevron)`
  height: 100%;
  transform: ${({ $isActive }) =>
    $isActive ? `rotate(0deg)` : `rotate(-180deg)`} !important;
`
